
import React, { useState, useEffect, useContext, useMemo, useRef } from "react";


import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
// import Sidebar from "../components/dashboard/sidebar";
import SideMenu from "./student/SideMenu";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../api/tmdbApi";
import moment from "moment";

import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import TableLoader from "../components/tableLoader";
import Loader from "../components/loader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import parse from "react-html-parser";
import SessionPopup from "../pages/SessionPopup";
// import { Tooltip } from "reactstrap";
import Tooltip from '@mui/material/Tooltip'


let { lambda, appname } = window.app

const ManageCase = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    const [toggle, setToggle] = useState(false);
    const [data, setData] = useState([]);
    // const [userdata, setUserData] = useState([]);
    const [user, setUser] = useState("");

    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message

    const [deleteShow, setDeleteShow] = useState(false);
    const [deleteUserId, setDeleteUserId] = useState(false);
    const [deleteBlocked, setDeleteBlocked] = useState(false);

    let id = localStorage.getItem("userId");

    const [flag, setFlag] = useState(false);
    const [usersearch, setUserSearch] = useState("");
    const [statusCounts, setStatusCounts] = useState({
        saved: 0,
        draft: 0
    });
    const [statusFilter, setStatusFilter] = useState(null);
    // "paged" = server-side pagination (list or search), "all" = full list loaded for the status filter
    const [listMode, setListMode] = useState("paged");
    const [totalRows, setTotalRows] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);
    const [activeSearch, setActiveSearch] = useState(""); // search term the loaded rows belong to
    const requestIdRef = useRef(0);
    const filteredData = useMemo(() => {
        if (!statusFilter) return data;

        return data.filter(row =>
            (row.status === "ACTIVE" ? "SAVED" :
                row.status === "INACTIVE" ? "DRAFT" :
                    row.status) === statusFilter
        );
    }, [data, statusFilter]);


    // const [isLoading, setIsLoading] = useState(false); 
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, userData, setcurrentPage, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity, isRestricted } = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Users")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // console.log('validate obj', validateObj)

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute != route) {
            setCurrentPage(1)
            setRowsPerPage(15)
            setSearchedFlag(false);
            setUserSearch("")
        }
    }, [prevRoute]);

    useEffect(() => {
        if (toastMessage) {
            toast.success(toastMessage, {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage("");
        }
    }, [toastMessage]);
    const isHtml = (str = "") => /<\/?[a-z][\s\S]*>/i.test(str);

    const stripHtml = (html = "") => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    };

    const decodeHtmlEntities = (str = "") => {
        const txt = document.createElement("textarea");
        txt.innerHTML = str;
        return txt.value;
    };

    const DescriptionColumn = {
        // ... other props
        name: 'Clinical History',
        selector: (row) => {
            const value = row?.clinicalhistory || "";
            return isHtml(value) ? decodeHtmlEntities(stripHtml(value)) : decodeHtmlEntities(value);
        },

        cell: (row) => {
            const value = row?.clinicalhistory || "";
            if (!value) return "-";

            const html = isHtml(value);
            const plainText = html ? decodeHtmlEntities(stripHtml(value)) : decodeHtmlEntities(value);

            // Trim display text
            const words = plainText.split(/\s+/);
            const isLong = words.length > 100;
            const displayText = isLong
                ? words.slice(0, 100).join(" ") + "… Read more"
                : plainText;

            // clean <h3> margins
            const cleanedHtml = html
                ? value.replace(/^<h3[^>]*>/i, "").replace(/<\/h3>$/i, "")
                : null;

            // Tooltip content
            const tooltipTitle = html ? (
                <div
                    style={{
                        maxHeight: "400px",
                        overflowY: "auto",
                        padding: "10px",
                        fontSize: "12px",
                        lineHeight: "20px",
                    }}
                >
                    {parse(cleanedHtml)}
                </div>
            ) : (
                plainText
            );

            return (
                <Tooltip
                    title={tooltipTitle}
                    placement="right-start"
                    classes={{ tooltip: "my-tooltip-parent" }}
                    PopperProps={{
                        modifiers: [
                            {
                                name: "preventOverflow",
                                options: {
                                    boundary: "viewport",
                                },
                            },
                        ],
                    }}
                >
                    <div
                        style={{
                            maxWidth: "400px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            cursor: "default",
                            fontSize: "12px",
                            lineHeight: "20px",
                        }}
                    >
                        {displayText}
                    </div>
                </Tooltip>
            );
        },
    };

    const keyForRerender = `${rowsPerPage}_${data?.length}`;
    const columns = [
        {
            name: 'Case Number',
            selector: row => row?.diagnosisid ?? "",
            sortable: true,
        },
        {
            name: 'Diagnosis',
            selector: row => row?.diagnosis ?? "",
            sortable: true,
        },

        DescriptionColumn,

        {
            name: 'Assign Modules',
            sortable: true,
            selector: (row) =>
                Array.isArray(row?.caseModules)
                    ? row.caseModules.join(', ')
                    : '',
            cell: (row) => {
                const modulesArray = Array.isArray(row?.caseModules) ? row.caseModules : [];
                const fullText = modulesArray.join(', ');
                const words = fullText.split(/\s+/);
                const isLong = words.length > 100;
                const displayText = isLong
                    ? words.slice(0, 100).join(' ') + '… Read more'
                    : fullText;

                return (
                    <Tooltip title={fullText} placement="top">
                        <div
                            style={{
                                maxWidth: '400px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                cursor: 'pointer',
                            }}
                        >
                            {displayText || '-'}
                        </div>
                    </Tooltip>
                );
            },
        },


        {
            name: 'Photos',
            selector: row => row?.histologyPhotoType === "JPEG/TIFF" ? "TIFF/JPEG" : (row?.histologyPhotoType ?? ""),
            sortable: true,
        },


        {
            name: 'Status',
            selector: row => row?.status == "ACTIVE" ? "SAVED" : row?.status == "INACTIVE" ? "DRAFT" : row?.status,
            sortable: true,
        },
        {
            name:

                'Actions'
            ,
            cell: (props) =>
                //   {

                <div className="d-flex">


                    <a
                        href={`/viewcase/${props.caseid}`}
                        onClick={saveListPosition}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-success action-button"
                    >
                        <i className="mdi mdi-eye font-size-18"></i>
                    </a>

                    <a onClick={(e) => handleEditUser(e, props.caseid)}
                        // className='text-danger action-button'
                        className={`text-danger action-button ${isRestricted ? "pe-none opacity-50" : ""}`}><i
                            className="mdi mdi-pencil font-size-18"></i> </a>

                    <a onClick={(e) => handleDeleteUser(e, props)}
                        // className='text-danger action-button'
                        className={`text-danger action-button ${isRestricted ? "pe-none opacity-50" : ""}`}><i
                            className="mdi mdi-delete font-size-18"></i> </a>

                </div>
            //  }
            ,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },

        {
            name: 'Created on',
            selector: row => row?.created,
            sortable: true,
            cell: (props) => props?.created ? dateFormat(props?.created) : "",
            // sortFunction: (a, b) => moment(a.created).diff(b.created),
        },

        {
            name: 'Created By',
            selector: row => row?.createdBy?.username ?? "",
        },


    ];



    const dateFormat = (created) => {

        const dateObj = new Date(created);

        // Extract date parts in IST
        const day = dateObj.toLocaleString('en-GB', { day: '2-digit', timeZone: 'Asia/Kolkata' });
        const month = dateObj.toLocaleString('en-GB', { month: '2-digit', timeZone: 'Asia/Kolkata' });
        const year = dateObj.toLocaleString('en-GB', { year: 'numeric', timeZone: 'Asia/Kolkata' });

        // Extract time parts in IST with AM/PM
        const time = dateObj.toLocaleString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: 'Asia/Kolkata'
        });

        // Combine date and time
        const formattedDateTime = `${day}-${month}-${year} ${time}`;
        return formattedDateTime.toUpperCase();
    }


    const handlePageChange = (page) => {
        // the data table re-fires this on mount (React StrictMode) - ignore when nothing changed
        if (page === currentPageNew) return;
        GetTimeActivity()
        setCurrentPage(page);
        if (listMode === "paged") {
            fetchCases({ page, search: activeSearch, paginate: true, showLoader: false });
        }
    };

    const handlePerRowsChange = (newPerPage) => {
        if (newPerPage === rowsPerPage) return;
        GetTimeActivity()
        setRowsPerPage(newPerPage);
        setCurrentPage(1);
        if (listMode === "paged") {
            fetchCases({ page: 1, perPage: newPerPage, search: activeSearch, paginate: true, showLoader: false });
        }
    };

    // Saved/Draft can't be filtered by the API, so filtering loads the full list and filters client-side
    const handleStatusFilter = (status) => {
        GetTimeActivity()
        setStatusFilter(status);
        setCurrentPage(1);
        if (status && listMode === "all") return; // full list already loaded
        fetchCases({ page: 1, search: activeSearch, paginate: !status });
    };


    // useEffect(() => {
    //     setRoute("user")
    //     // setActiveMenuId(200003)
    //     setData([])
    //     // userActivity();
    //     if (!localStorage.getItem("token")) {
    //         navigate("/");
    //     }
    // }, []);
    useEffect(() => {
        console.log("🔁 useEffect triggered");

        setRoute("user");
        console.log("📍 Route set to: user");

        setData([]);
        console.log("🧹 Data reset");

        const token = localStorage.getItem("token");
        console.log("🔐 Token:", token);

        if (!token) {
            console.log("🚫 No token found, navigating to login");
            navigate("/");
            return;
        }

        // Check if there's a saved search query
        const savedSearchQuery = localStorage.getItem("caseSearchQuery");
        console.log("💾 Saved Search Query:", savedSearchQuery);

        if (savedSearchQuery) {
            console.log("🔍 Using saved search query");
            setUserSearch(savedSearchQuery);

            setTimeout(() => {
                console.log("⏱ Triggering search from saved query");
                setSearchedFlag(true);
            }, 100);
        } else {
            console.log("👤 No search found, calling User()");
            // coming back from edit/view restores the saved page; from any other menu start on page 1
            // (currentPageNew is shared context and may still hold another menu's page)
            const savedPosition = state?.restoreListPage ? getSavedListPosition() : null;
            if (savedPosition) {
                setRowsPerPage(savedPosition.perPage);
                setCurrentPage(savedPosition.page);
                User(savedPosition.page, savedPosition.perPage);
            } else {
                setCurrentPage(1);
                User(1);
            }
        }

        return () => {
            console.log("🧹 Cleanup: Resetting searchedFlag");
            setSearchedFlag(false);
        };

    }, []);



    // useEffect(() => {
    //     if (searchedFlag) {
    //         handleSearch();
    //     } else {
    //         User();
    //     }

    // }, [searchedFlag]);


    useEffect(() => {
        if (searchedFlag && usersearch.trim().length > 0) {
            handleSearch();
        }
    }, [searchedFlag, usersearch]); // Add usersearch as dependency
    // single fetch for the cases list and search; paginate=false loads every row (used by the status filter)
    const fetchCases = ({ page = 1, perPage = rowsPerPage, search = "", paginate = !statusFilter, showLoader = true }) => {
        const requestId = ++requestIdRef.current;
        showLoader ? setIsLoading(true) : setTableLoading(true)
        const userId = localStorage.getItem("userId")
        const token = localStorage.getItem("token")
        const searchQuery = search ? "&search=" + encodeURIComponent(search) : ""
        const pageQuery = paginate ? "&paginate=true&pageNumber=" + page + "&pageSize=" + perPage : ""
        axios({
            method: 'POST',
            url: lambda + '/learningCaseInfo?appname=' + appname + '&userid=' + userId + '&token=' + token + "&projection=admincases" + searchQuery + pageQuery,
        })
            .then(function (response) {
                // a newer request went out while this one was in flight - drop this response
                if (requestId !== requestIdRef.current) return;

                if (response?.data?.result === "Invalid token or Expired") {
                    setIsLoading(false)
                    setTableLoading(false)
                    setShowSessionPopupup(true)
                    //                 localStorage.clear();
                    //    navigate("/")
                } else {
                    const result = response?.data?.result
                    const rows = result?.questionData ?? []

                    // page is past the end (e.g. last row on the page was deleted) - step back one page
                    if (paginate && rows.length === 0 && page > 1) {
                        setCurrentPage(page - 1)
                        fetchCases({ page: page - 1, perPage, search, paginate, showLoader })
                        return
                    }

                    if (!search) setUser(rows);
                    setData(rows);
                    global.exportExcelData = rows

                    setStatusCounts({
                        saved: result?.savedCount,
                        draft: result?.draftCount
                    });
                    setTotalRows(result?.totalCount ?? rows.length);
                    setListMode(paginate ? "paged" : "all");
                    setActiveSearch(search);

                    setIsLoading(false);
                    setTableLoading(false);
                    // setUserSearch("");
                    // setSearchedFlag(false);
                    const savedSearchQuery = localStorage.getItem('caseSearchQuery');
                    if (!search && !savedSearchQuery) {
                        setUserSearch("");
                        setSearchedFlag(false);
                    }
                }
            }).catch((err) => {
                if (requestId !== requestIdRef.current) return;
                console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
                setTableLoading(false);
            });
    }

    const User = (page = currentPageNew, perPage = rowsPerPage, showLoader = true, paginate = !statusFilter) => {
        fetchCases({ page, perPage, paginate, showLoader });
    }

    console.log('user search', usersearch)

    const handleSearch = (e, flagggg) => {
        GetTimeActivity();

        const inputQuery = usersearch;

        // ✅ Empty / whitespace-only validation
        if (inputQuery.trim().length === 0) {
            toast.error("Search field cannot be empty.");
            return;
        }

        setCurrentPage(1);
        fetchCases({ page: 1, search: inputQuery });
    };


    const handleChange = (e) => {
        if (e.target.value === "") {
            //   User();
            setFlag(false)
        }
        setUserSearch(e.target.value)
    }



    const handleKeypress = (e) => {
        //it triggers by pressing the enter key
        GetTimeActivity()
        if ((e.key === "Enter")) {
            setTimeout(function () {
                handleSearch();
            }, 1000);
        }
    };
    const handleAddUser = (e) => {
        navigate("/addcase");
    }

    // const handleEditUser = (e, paramuserid) => {
    //     console.log('paramuserid', paramuserid)
    //     // navigate("/editcase/" + paramuserid);
    //     // navigate("/editcase/" + paramuserid, {
    //     //     state: { searchQuery: usersearch }
    //     // });
    //     if (usersearch.trim().length > 0) {
    //         localStorage.setItem('caseSearchQuery', usersearch);
    //     }
    //     navigate("/editcase/" + paramuserid);
    // }
    // edit/view open in a new tab, so the list position goes to localStorage (shared across tabs)
    const saveListPosition = () => {
        localStorage.setItem("casesListPosition", JSON.stringify({ page: currentPageNew, perPage: rowsPerPage }));
    };

    const getSavedListPosition = () => {
        try {
            const saved = JSON.parse(localStorage.getItem("casesListPosition"));
            return saved?.page && saved?.perPage ? saved : null;
        } catch {
            return null;
        }
    };

    const handleEditUser = (e, paramuserid) => {
        e.preventDefault();
        saveListPosition();

        // if (usersearch.trim().length > 0) {
        //     localStorage.setItem('caseSearchQuery', usersearch);
        // }

        window.open(`/editcase/${paramuserid}`, "_blank", "noopener,noreferrer");
    };

    useEffect(() => {
        // Restore search query if coming back from edit page
        if (state?.searchQuery) {
            setUserSearch(state.searchQuery);
            setSearchedFlag(true);
        }
    }, [state]);

    const handleDeleteUser = (e, row) => {
        const hasModules = Array.isArray(row?.caseModules) && row.caseModules.length > 0;
        if (hasModules) {
            setDeleteBlocked(true);
        } else {
            setDeleteUserId(row.caseid)
            setDeleteShow(true)
        }
    }

    const onDeleteCancel = (e) => {
        setDeleteShow(false)
        setDeleteUserId(null)

    }

const handleDelete = async (e) => {
        setDeleteShow(false)

        try {
            await tmdbApi.caseDelete(deleteUserId);
            setDeleteUserId(null)
            // reload the page the user is on (search or not)
            fetchCases({ page: currentPageNew, search: activeSearch });
            setToastMessage("Deleted Successfully")
        } catch {
            console.log("error");
        }
    }


    const clearSearch = () => {
        GetTimeActivity()
        setUserSearch("");
        setCurrentPage(1);
        User(1);
        setcurrentPage(1);
        localStorage.removeItem('caseSearchQuery');
    }

    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No data were found</p>
                </div> </div>
        )
    }


    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {

            const aField = String(selector(rowA)).toLowerCase();

            //  const bField = selector(rowB);
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });


        global.exportExcelData = sortedData

        return sortedData;
    };
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper" className="create-case-db">
                <Header />
                <SideMenu />

                {/* Start right Content here  */}

                <div className="main-content user-management create-case" id="main-content">
                    <div className="page-content create-case-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">

                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="breadcrumb-title">CASES</h4>
                                        </div>

                                        <div className="d-flex gap-2">

                                            {/* <button
                                                className="btn btn-primarys create-quiz-btn"
                                                onClick={() => navigate("/bulkimageupload")}
                                                id="bulk-image-upload-btn"
                                            >
                                                <i className="mdi mdi-image-multiple me-1"></i>
                                                BULK IMAGE UPLOAD
                                            </button> */}
    <button
                                                className="btn btn-primarys create-quiz-btn"
                                                onClick={() => navigate("/casesupload")}
                                                id="bulk-image-upload-btn"
                                            >
                                              <i className="mdi mdi-file-plus-outline" ></i>
                                               &nbsp; IMPORT UPDATE CASES
                                            </button>

                                            {/* <button
                                                id="import-update-cases-btn"
                                                onClick={() => navigate("/casesupload")}
                                                style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: "7px",
                                                    padding: "8px 16px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    letterSpacing: "0.4px",
                                                    border: "none",
                                                    borderRadius: "8px",
                                                    cursor: "pointer",
                                                    backgroundColor: "#0EA5E9",
                                                    color: "#fff",
                                                    whiteSpace: "nowrap",
                                                    fontFamily: "Montserrat, sans-serif",
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                <i className="mdi mdi-file-import" style={{ fontSize: "16px" }}></i>
                                                IMPORT <span style={{ backgroundColor: "#fff", color: "#0EA5E9", padding: "1px 7px", borderRadius: "4px", fontWeight: "800" }}>UPDATE</span> CASES
                                            </button> */}

                                            <button
                                                id="create-cases-import-btn"
                                                onClick={() => navigate("/casescreate")}
                                                style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: "7px",
                                                    padding: "8px 16px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    letterSpacing: "0.4px",
                                                    border: "none",
                                                    borderRadius: "8px",
                                                    cursor: "pointer",
                                                    backgroundColor: "#0D9488",
                                                    color: "#fff",
                                                    whiteSpace: "nowrap",
                                                    fontFamily: "Montserrat, sans-serif",
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                <i className="mdi mdi-file-plus-outline" style={{ fontSize: "16px" }}></i>
                                                IMPORT <span style={{ backgroundColor: "#fff", color: "#0D9488", padding: "1px 7px", borderRadius: "4px", fontWeight: "800" }}>CREATE</span> CASES
                                            </button>


                                            <button className="btn btn-primarys create-quiz-btn" onClick={handleAddUser}
                                                disabled={isRestricted} id="add-user-btn">
                                                CREATE CASE
                                            </button>
                                        </div>


                                    </div>
                                </div>
                            </div>

                            <div className="row table-data" id="table-data-row">
                                <div className="col-12">
                                    <div className="card" id="card">
                                        <div className="card-body" id="card-body">
                                            {isLoading ? <Loader /> : <>
                                                <div className="row justify-content-between align-items-end" id="table-header-row">
                                                    <div className="col-sm-12 col-md-5 col-lg-4 button-block mb-3" id="button-block">
                                                        <div className="d-flex align-items-center gap-2">

                                                    {/* SAVED */}
                                                    <button
                                                        className={`btn btn-sm rounded px-3 fw-semibold ${statusFilter === "SAVED"
                                                                ? "text-white"
                                                                : "btn-light text-dark"
                                                            }`}
                                                        onClick={() => handleStatusFilter("SAVED")}
                                                        style={
                                                            statusFilter === "SAVED"
                                                                ? { backgroundColor: "var(--secondaryColor)", border: "1px solid var(--secondaryColor)" }
                                                                : { border: "1px solid #ddd" }
                                                        }
                                                    >
                                                        Saved
                                                        <span
                                                            className="ms-2 badge rounded"
                                                            style={{
                                                                backgroundColor: statusFilter === "SAVED" ? "white" : "var(--secondaryColor)",
                                                                color: statusFilter === "SAVED" ? "var(--secondaryColor)" : "white",
                                                            }}
                                                        >
                                                            {statusCounts.saved}
                                                        </span>
                                                    </button>

                                                    {/* DRAFT */}
                                                    <button
                                                        className={`btn btn-sm rounded px-3 fw-semibold ${statusFilter === "DRAFT"
                                                                ? "text-white"
                                                                : "btn-light text-dark"
                                                            }`}
                                                        onClick={() => handleStatusFilter("DRAFT")}
                                                        style={
                                                            statusFilter === "DRAFT"
                                                                ? { backgroundColor: "var(--secondaryColor)", border: "1px solid var(--secondaryColor)" }
                                                                : { border: "1px solid #ddd" }
                                                        }
                                                    >
                                                        Draft
                                                        <span
                                                            className="ms-2 badge rounded"
                                                            style={{
                                                                backgroundColor: statusFilter === "DRAFT" ? "white" : "var(--secondaryColor)",
                                                                color: statusFilter === "DRAFT" ? "var(--secondaryColor)" : "white",
                                                            }}
                                                        >
                                                            {statusCounts.draft}
                                                        </span>
                                                    </button>

                                                    {/* CLEAR ICON */}
                                                    {statusFilter && (
                                                        <button
                                                            className="btn btn-sm btn-light rounded d-flex align-items-center justify-content-center"
                                                            style={{ width: "30px", height: "30px", border: "1px solid #ddd" }}
                                                            onClick={() => handleStatusFilter(null)}
                                                            title="Clear filter"
                                                        >
                                                            <i className="mdi mdi-close text-dark"></i>
                                                        </button>
                                                    )}

                                                </div>
                                                    </div>
                                                    <div className="col-sm-12 col-md-7 col-lg-8">
                                                        <div className="search-box d-inline-block" id="search-box">
                                                            <div className="position-relative">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={usersearch}
                                                                    onChange={(e) => handleChange(e)}
                                                                    placeholder="Search by Case Number and Case Diagnosis"
                                                                    onKeyPress={handleKeypress}
                                                                    id="search-input"
                                                                />
                                                                <button
                                                                    className="fill_btn"
                                                                    onClick={(e) => handleSearch(e, "normalsearch")}
                                                                    id="search-btn">
                                                                    <span className="material-icons search-icon">search</span>
                                                                </button>
                                                            </div>
                                                            <div className="dataTables_length" id="datatable-length-reset">
                                                                <button
                                                                    className="fill_btn"
                                                                    onClick={clearSearch}
                                                                    id="reset-btn">
                                                                    <span className="material-icons-outlined">sync</span>Reset
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="text-sm-end" id="text-end"></div>
                                                    </div>
                                                </div>
                                                


                                                <DataTable
                                                    key={keyForRerender}
                                                    columns={columns}
                                                    className="case-table"
                                                    keyField='_id'
                                                    data={filteredData}
                                                    // data={data}
                                                    direction="auto"
                                                    highlightOnHover
                                                    fixedHeaderScrollHeight="300px"
                                                    pagination
                                                    paginationServer={listMode === "paged"}
                                                    progressPending={tableLoading}
                                                    progressComponent={<TableLoader />}
                                                    responsive
                                                    persistTableHead
                                                    striped
                                                    subHeaderAlign="right"
                                                    defaultSortField="name"
                                                    noDataComponent={customNoRecords()}
                                                    paginationTotalRows={listMode === "paged" ? totalRows : filteredData?.length}
                                                    onChangeRowsPerPage={handlePerRowsChange}
                                                    onChangePage={handlePageChange}
                                                    paginationPerPage={rowsPerPage}
                                                    paginationDefaultPage={currentPageNew}
                                                    paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                    sortFunction={customSort}
                                                    paginationComponentOptions={{
                                                        rowsPerPageText: 'Per page:',
                                                        rangeSeparatorText: 'of',
                                                        noRowsPerPage: false,
                                                        selectAllRowsItem: false,
                                                        selectAllRowsItemText: 'All',
                                                    }}

                                                    id="data-table"
                                                />

                                            </>}

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <SweetAlert
                        show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Something went wrong. Please reload again."}
                        onConfirm={e => setTableErrMsg(false)}
                        id="error-alert"
                    ></SweetAlert>


                    <SweetAlert
                        show={deleteBlocked}
                        warning
                        confirmBtnText="Close"
                        confirmBtnBsStyle="danger"
                        title="Cannot Delete Case"
                        onConfirm={() => setDeleteBlocked(false)}
                    >
                        This case is currently assigned to one or more modules and cannot be deleted. Please unassign the modules before deleting.
                    </SweetAlert>

                    <SweetAlert
                        show={deleteShow}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Are you sure you want to delete?"
                        focusCancelBtn
                        onConfirm={e => handleDelete(e)}
                        onCancel={e => onDeleteCancel(e)}
                    >
                    </SweetAlert>
                    {/* ✅ Toast container should be here */}
                    <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        pauseOnHover
                        draggable
                    />


                    <Footer id="footer" />
                </div>





            </div>
            <style>
                {`
                    .user-management .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(2), .user-management .rdt_Table .rdt_TableBody .rdt_TableRow
                    .rdt_TableCell:nth-child(2) {
                            min-width: 17% !important;
                        },
                        .user-management .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell div:first-child {text-align: start;}
                    `}
            </style>
        </>
    );
};

export default ManageCase;